import React, { useState, useEffect } from "react";
import { Checkbox, Input, Button, Form, Radio, DatePicker, Typography, Divider, Card } from "antd";
import moment from "moment";
import 'antd/dist/reset.css';
import './Reservation.css';
import dayjs from 'dayjs';
import {API_BASE_URL_ISSUER} from "../../../services/apiConfig";
import { API_BASE_URL } from "../../../services/apiConfig";
import AuthService from "../../../services/auth.service";
import { useParams } from "react-router-dom";
const { Title } = Typography;

const timeSlots = [
  "9:30~10:00", "10:00~10:30", "10:30~11:00", "11:00~11:30", "11:30~12:00",
  "12:00~12:30", "12:30~13:00", "13:00~13:30", "13:30~14:00", "14:00~14:30",
  "14:30~15:00", "15:00~15:30", "15:30~16:00", "16:00~16:30", "16:30~17:00",
  "17:00~17:30", "17:30~18:00", "18:00~18:30", "18:30~19:00", "19:00~19:30",
  "19:30~20:00"
];

const fieldsOfCare = [
  "내과", "외과", "정형외과", "소아과", "산부인과", "안과", "치과", "피부과", "비뇨기과", "기타"
];

const Reservation: React.FC = () => {
  const [selectedTimeSlots, setSelectedTimeSlots] = useState<string[]>([]);
  const [selectedFields, setSelectedFields] = useState<string[]>([]);
  const [medications, setMedications] = useState<string>("");
  const [pastHistory, setPastHistory] = useState<string>("");
  const [hospitalized, setHospitalized] = useState<string>("N");
  const [surgery, setSurgery] = useState<string>("N");
  const [allergies, setAllergies] = useState<string>("N");
  const [consent, setConsent] = useState<boolean>(false);
  const [patientInfo, setPatientInfo] = useState({
    name: "",
    birthDate: "",
    gender: "",
    phoneNumber: ""
  });
  const [isFirstVisit, setIsFirstVisit] = useState<string>("N");
  const { clubSeq } = useParams<{ clubSeq: string }>(); // useParams를 사용하여 clubSeq 값을 가져옴
  const [selectedDate, setSelectedDate] = useState<dayjs.Dayjs | null>(null);
  const handleDateChange = (date: dayjs.Dayjs | null) => {
    setSelectedDate(date);
    setSelectedTimeSlots([]);
  };
  const disabledDate = (current: dayjs.Dayjs | null) => {
    if (!current) return false;
    const today = dayjs().startOf('day'); // 현재 날짜의 자정
    const todayPlus3 = today.add(3, 'day').endOf('day'); // 오늘부터 3일 후의 자정 직전

    // 3일 이후의 자정 직전 날짜
    const todayPlus3EndOfDay = todayPlus3.startOf('day').add(1, 'day').subtract(1, 'second');

    // 월요일의 경우 3일 이전까지만 선택 가능하도록 처리
    if (today.day() === 1) { // 오늘이 월요일 (day() 함수는 0부터 일요일)
      const mondayPlus3 = today.add(3, 'day').endOf('day');
      return current.isBefore(today) || current.isBefore(mondayPlus3);
    }

    // 그 외의 경우, 오늘 이전이거나 오늘부터 3일 후의 자정 직전까지만 선택 불가능하게 처리
    return current.isBefore(today) || current.isBefore(todayPlus3EndOfDay);
  };
  useEffect(() => {
    console.log("clubSeq:", clubSeq); // clubSeq 값을 콘솔에 출력
  }, [clubSeq]);
  const handleSubmit = () => {
    if (consent) {
      const formData = {
        예약: [
          ...selectedTimeSlots.map(slot => ({ name: "예약 가능 시간대", input: [slot] })),
          ...selectedFields.map(field => ({ name: "진료 분야", input: [field] })),
          { name: "현재 복용 중인 약물", input: [medications] },
          { name: "과거 병력", input: [pastHistory] },
          { name: "입원 경험", input: [hospitalized] },
          { name: "수술 경험", input: [surgery] },
          { name: "알러지 유무", input: [allergies] },
          { name: "개인정보 수집 동의", input: ["동의합니다"] },
          { name: "성명", input: [patientInfo.name] },
          { name: "생년월일", input: [patientInfo.birthDate] },
          { name: "성별", input: [patientInfo.gender] },
          { name: "핸드폰 번호", input: [patientInfo.phoneNumber] },
          { name: "첫 방문이신가요?", input: [isFirstVisit] },
          { name: "예약 날짜", input: [selectedDate?.format("YYYY-MM-DD") || ""] }
        ]
      };

      const output = {
        clubSeq: clubSeq,
        mobileNumber: patientInfo.phoneNumber,
        questionnaire: JSON.stringify(formData),
        sms: true,
        push: true,
        reInvite: false,
        onlySaveSms: false,
      };

      console.log("보내는값 : " + JSON.stringify(output, null, 2))

      fetch(`${API_BASE_URL}/reservation`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(output, null, 2),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("(Reservation) Network response was not ok");
          }
          return response.json();
        })
        .then((data) => {
          alert('감사합니다. 곧 예약확인 전화를 드리겠습니다.');

          if (isFirstVisit === "Y") {
            window.location.href = "https://avchain.io/rhymecard";
          }
        })
        .catch((error) => {
          let errorMessage =
            "예약이 되지않았습니다. 입력된 정보를 확인해주세요";

          alert(errorMessage);
          console.error("(Reservation) Error:", error);
        });



    } else {
      alert('개인정보 수집 동의를 해주세요.');
    }
  };

  return (
    <div className="reservation-container">
      <Card className="reservation-card">
        <Title level={2}>예약 신청</Title>
        <Form onFinish={handleSubmit} layout="vertical">
          <Form.Item label="예약 날짜">
            <DatePicker
              clearIcon
              onChange={handleDateChange}
              value={selectedDate}
              format="YYYY-MM-DD"
              disabledDate={disabledDate}
            />
          </Form.Item>
          <Form.Item label="예약 가능 시간대">
            <Checkbox.Group
              options={timeSlots}
              value={selectedTimeSlots}
              onChange={(checkedValues) => setSelectedTimeSlots(checkedValues as string[])}
            />
          </Form.Item>

          <Form.Item label="진료 분야">
            <Checkbox.Group
              options={fieldsOfCare}
              value={selectedFields}
              onChange={(checkedValues) => setSelectedFields(checkedValues as string[])}
            />
          </Form.Item>

          <Form.Item label="현재 복용 중인 약물">
            <Input.TextArea value={medications} onChange={(e) => setMedications(e.target.value)} />
          </Form.Item>

          <Form.Item label="과거 병력">
            <Input.TextArea value={pastHistory} onChange={(e) => setPastHistory(e.target.value)} />
          </Form.Item>

          <Form.Item label="입원 경험">
            <Radio.Group value={hospitalized} onChange={(e) => setHospitalized(e.target.value)}>
              <Radio value="Y">예</Radio>
              <Radio value="N">아니오</Radio>
            </Radio.Group>
          </Form.Item>

          <Form.Item label="수술 경험">
            <Radio.Group value={surgery} onChange={(e) => setSurgery(e.target.value)}>
              <Radio value="Y">예</Radio>
              <Radio value="N">아니오</Radio>
            </Radio.Group>
          </Form.Item>

          <Form.Item label="알러지 유무">
            <Radio.Group value={allergies} onChange={(e) => setAllergies(e.target.value)}>
              <Radio value="Y">예</Radio>
              <Radio value="N">아니오</Radio>
            </Radio.Group>
          </Form.Item>

          <Form.Item label="개인정보 수집 동의">
            <Checkbox checked={consent} onChange={(e) => setConsent(e.target.checked)}>동의합니다</Checkbox>
          </Form.Item>

          <Form.Item label="성명">
            <Input value={patientInfo.name} onChange={(e) => setPatientInfo({ ...patientInfo, name: e.target.value })} />
          </Form.Item>

          <Form.Item label="생년월일">
            <DatePicker
              clearIcon
              value={patientInfo.birthDate ? dayjs(patientInfo.birthDate) : null}
              onChange={(date) => setPatientInfo({ ...patientInfo, birthDate: date?.format('YYYY-MM-DD') || "" })}
            />
          </Form.Item>

          <Form.Item label="성별">
            <Radio.Group value={patientInfo.gender} onChange={(e) => setPatientInfo({ ...patientInfo, gender: e.target.value })}>
              <Radio value="male">남성</Radio>
              <Radio value="female">여성</Radio>
            </Radio.Group>
          </Form.Item>

          <Form.Item label="핸드폰 번호">
            <Input value={patientInfo.phoneNumber} onChange={(e) => setPatientInfo({ ...patientInfo, phoneNumber: e.target.value })} />
          </Form.Item>

          <Form.Item label="첫 방문이신가요?">
            <Radio.Group value={isFirstVisit} onChange={(e) => setIsFirstVisit(e.target.value)}>
              <Radio value="Y">예</Radio>
              <Radio value="N">아니오</Radio>
            </Radio.Group>
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" block>예약 신청</Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default Reservation;
